import React, { useEffect, useState } from 'react';
import './App.css';

import Navbar from "./Navbar";

import { createFFmpeg, fetchFile } from "@ffmpeg/ffmpeg";

const ffmpeg = createFFmpeg({ log: true });

function App() {
  const [ready, setReady] = useState(false);
  const [video, setVideo] = useState<File | undefined | null>();
  const [gif, setGif] = useState<string | undefined | null>();

  const load = async () => {
    if (ffmpeg.isLoaded()) {
      return
    }
    await ffmpeg.load();
    setReady(true)
  }

  useEffect( () => {
    load();
  }, [])

  const convertToGif = async () => {
    if (video === null || video === undefined) {
      alert("cannot convert to gif, please try again");
    } else {
      ffmpeg.FS("writeFile", "video.mp4", await fetchFile(video));
      
      await ffmpeg.run("-i", "video.mp4", "-t", "2.5", "-ss", "2.0", "-f", "gif", "out.gif")
        .catch( () => {
          alert("cannot convert to gif, please try again")
          setGif(null)
          return
        }
      );

      const data = ffmpeg.FS("readFile", "out.gif");
      const url = URL.createObjectURL(new Blob([data.buffer], { type: "image/gif" }));
      setGif(url)
    }
  }

  return ready ? (
    <Navbar>
      <div className="App">
        <br/>
        <br/>
        { video && <video controls width="250" src={URL.createObjectURL(video)}></video>}
        <br/>
        <br/>
        <input type="file" onChange={(e) => setVideo(e.target.files?.item(0))}/>
        <br/>
        <br/>
        <button onClick={convertToGif}>convert</button>
  
        { gif &&
          <>
            <h3>result</h3>
            <img src={gif} alt="converted video"/>
          </>
        }
      </div>
    </Navbar>
  ) : 
  (<p className="loading"><b>loading...</b></p>);
}

export default App;
